import { ModalSimilars } from "../ModalSimilars/web";
import { useIsAuthModalShowing } from "../../../GlobalHooks/useIsAuthModalShowing";
import { useTheme } from "../../../Styles/ThemeHook";
import { OwnerLogo } from "../OwnerLogo/web";
import { Col, Row, Typography } from "antd";
import "./styles.less"
import { formatPhone } from "src/utils/Functions";
import { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

type Props = {
	visible:boolean,
	onCancel:()=>void,
	loading:boolean,
	owner_name:string,
	phone:string,
	property_id: string | number,
	property_code?: string;
	owner: any;
	width?: number;
	mode?:any,
	onClick?: () => void,
	icon?: React.ReactNode
}

export const ModalPhone = (props:Props) => {
	const { theme } = useTheme();
	const { isAuthModalShowing } = useIsAuthModalShowing();
	const { country_code } = useContext(ConfigStateContext);
	let phones = [];

	if (typeof props.phone != "undefined" && props.phone) phones = props.phone.split(";");

	return (
		<ModalSimilars
			mode={props.mode}
			width={props.width ?? 420}
			visible={props.visible && !isAuthModalShowing}
			onCancel={props.onCancel}
			property_id={props.property_id}
		>
			<Row
				className={"modal-phone-content"}
				justify={"center"}
				style={{ textAlign: "center" }}
				gutter={[0, theme.spacing.xsSpacing]}
			>
				<Col span={24}>
					<Typography.Text style={{ fontSize: "20px" }}>
						{"¿Te interesa esta propiedad?"}
					</Typography.Text>
					<br/>
					{!!props.property_code && <Typography.Text strong style={{ fontSize: "20px" }}>
						Ref. InfoCasas {props.property_code}
					</Typography.Text>}
				</Col>

				<Col span={24} style={{marginBottom: 20, marginTop: 20, padding: 0}}>
					{!!props.owner?.logo ? 
					<div className="logo-container">
						<OwnerLogo
							logo={props.owner.logo}
							name={props.owner.name}
							inmoLink={props.owner.inmoLink}
							inmoPropsLink={props.owner.inmoPropsLink}
							inmoFull={props.owner.inmofull}
						/>
					</div> :
					<Typography.Text strong>{props.loading ? "loading" : props.owner_name}</Typography.Text>}
				</Col>

				<div style={{display: "flex", justifyContent: "center", gap: 10, flexWrap: 'wrap'}}>
					{phones.map((phone, i) => (
						<div key={"phone_" + i}>
							<a href={"tel:" + phone} onClick={props.onClick}>
								<button className="btn-phone">									
									{props.icon ?? null}
									{props.loading ? "loading" : formatPhone({phone, countryCode: country_code})}
								</button>
							</a>
						</div>
					))}
				</div>
			</Row>
		</ModalSimilars>
	);
};


